import { render, staticRenderFns } from "./GelirGiderTurPicker.vue?vue&type=template&id=0a05799d"
import script from "./GelirGiderTurPicker.vue?vue&type=script&lang=ts"
export * from "./GelirGiderTurPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports